import { Config } from '../../models/config/config';

let bodyOverflow;

function elapsedTime(delta) {
  delta = parseInt(delta / 1000);
  let remainder = 0;
  if (!delta) {
    return '';
  }
  const w = delta > 604800 ? parseInt(delta / 604800) : 0;
  remainder = delta > 604800 ? delta % 604800 : delta;

  const d = remainder > 86400 ? parseInt(remainder / 86400) : 0;
  remainder = remainder > 86400 ? remainder % 86400 : remainder;

  const h = delta > 3600 ? parseInt(remainder / 3600) : 0;
  remainder = remainder > 3600 ? remainder % 3600 : remainder;

  const m = remainder > 60 ? parseInt(remainder / 60) : 0;

  const s = remainder > 60 ? remainder % 60 : remainder;
  if (w > 0) {
    return `${w} w ${d} d`;
  }
  if (d > 0) {
    return `${d} d ${h} h`;
  }
  if (h > 0) {
    return `${h} h ${m} m`;
  }
  if (m > 0) {
    return `${m} m ${s} s`;
  }
  return `${s} s`;
}

function formatBuildDate(x) {
  let am_pm = 'am';
  const y = new Date(x);
  const isDate = y instanceof Date && !Number.isNaN(y.getTime());
  if (!x || !isDate) {
    return '';
  }
  const year = y.getFullYear();
  const month = y.getMonth() + 1;
  const day = y.getDate();
  let hour = y.getHours();
  am_pm = hour > 11 ? 'pm' : 'am';
  hour = hour > 12 ? hour - 12 : hour;
  const minutes = y.getMinutes();
  return `${month}-${day}-${year} ${hour}:${minutes < 10 ? '0' : ''}${minutes}${am_pm}`;
}
function close() {
  const container = document.getElementById('trellis_build_data_container');
  if (container) {
    container.parentNode.removeChild(container);
  }
  const styling = document.getElementById('arbor-build-info-styling');
  if (styling) {
    styling.remove();
  }
  document.body.style.overflow = bodyOverflow || null;
}
async function displayResults() {
  close();
  const build_info_response = (await Config.getBuildInfo()) || { try: 'catch' };
  try {
    console.log('Build Info', JSON.stringify(build_info_response, null, 4));
  } catch (e) {
    console.log('Build Info-error', e);
  }
  const styling = document.createElement('style');
  styling.type = 'text/css';
  styling.id = 'arbor-build-info-styling';
  styling.innerHTML = `
    #arbor_build_info_table tr td:nth-child(4), #arbor_build_info_table tr td:nth-child(5), #arbor_build_info_table tr td:nth-child(6), #arbor_build_info_table tr td:nth-child(7) {
    text-align: center;
    }
    #arbor_build_info_table tbody:nth-child(even) tr {
    background-color: white;
    }
    #arbor_build_info_table tbody tr td {
    padding: 12px 15px;
    }
    #arbor_build_info_table tbody tr th {
    padding: 0 0 10px 0;
    }
  `;
  document.head.appendChild(styling);
  const root = document.getElementById('root') || document.body;
  // UI
  const ui_build_date_element = document.querySelector('meta[name="arbor-ui-build-date"]');
  const ui_build_date = ui_build_date_element?.getAttribute('content') || null;
  const ui_build_date_formatted = formatBuildDate(ui_build_date);
  const ui_elapsed_time_delta = new Date().getTime() - new Date(ui_build_date).getTime();
  const ui_build_time_elapsed = ui_build_date ? elapsedTime(ui_elapsed_time_delta) : '';
  const ui_commit_element = document.querySelector('meta[name="arbor-ui-commit"]');
  const ui_commit = ui_commit_element
    ? ui_commit_element.getAttribute('content').substring(0, 8)
    : '';
  const ui_branch_element = document.querySelector('meta[name="arbor-ui-branch"]');
  const ui_branch_value = ui_branch_element?.getAttribute('content');
  const ui_branch_link = `<a target="_blank" href="https://github.com/optum-rx-pharm-care-svcs/cps-arbor-ui/commits/${ui_branch_value}?deployed=${ui_commit}">${ui_branch_value}</a>`;
  const ui_branch = ui_branch_element ? ui_branch_link : '';
  // Services
  const services_build_date = build_info_response.servicesConfig?.build_date;
  const services_build_date_formatted = formatBuildDate(services_build_date);
  const services_elapsed_time_delta =
    new Date().getTime() - new Date(services_build_date).getTime();
  const services_build_time_elapsed = services_build_date
    ? elapsedTime(services_elapsed_time_delta)
    : '';
  const services_running = build_info_response.servicesConfig?.running_count;
  const services_desired = build_info_response.servicesConfig?.desired_count;
  const service_pending = build_info_response.servicesConfig?.pending_count;
  const services_commit = build_info_response?.servicesConfig?.commit;
  const services_branch = build_info_response?.servicesConfig?.branch;
  const services_branch_link = `<a target="_blank" href="https://github.com/optum-rx-pharm-care-svcs/cps-arbor-services/commits/${services_branch}?deployed=${services_commit}">${services_branch}</a>`;
  // SQL
  const sql_build_date_element = document.querySelector('meta[name="arbor-sql-build-date"]');
  const sql_build_date = sql_build_date_element?.getAttribute('content') || null;
  const sql_build_date_formatted = formatBuildDate(sql_build_date);
  const sql_elapsed_time_delta = new Date().getTime() - new Date(sql_build_date).getTime();
  const sql_build_time_elapsed = sql_build_date ? elapsedTime(sql_elapsed_time_delta) : '';
  const sql_commit_element = document.querySelector('meta[name="arbor-sql-commit"]');
  const sql_commit = sql_commit_element
    ? sql_commit_element.getAttribute('content').substring(0, 8)
    : '';
  const sql_branch_element = document.querySelector('meta[name="arbor-sql-branch"]');
  let sql_branch_value = sql_branch_element?.getAttribute('content')?.replace('-', '/');

  if (sql_branch_value && sql_branch_value.substring(0, 7) === 'origin/') {
    sql_branch_value = sql_branch_value.substring(7);
  }

  const sql_branch_link = `<a target="_blank" href="https://github.com/optum-rx-pharm-care-svcs/cps-arbor-sql/commits/${sql_branch_value}?deployed=${sql_commit.substring(
    0,
    8,
  )}">${sql_branch_value}</a>`;
  const sql_branch = sql_branch_element ? sql_branch_link : '';
  // Lambda
  const lambda_build_date_element = document.querySelector('meta[name="arbor-lambda-build-date');
  const lambda_build_date = lambda_build_date_element?.getAttribute('content') || null;
  const lambda_build_date_formatted = formatBuildDate(lambda_build_date);
  const lambda_elapsed_time_delta = new Date().getTime() - new Date(lambda_build_date).getTime();
  const lambda_build_time_elapsed = lambda_build_date ? elapsedTime(lambda_elapsed_time_delta) : '';
  const lambda_commit_element = document.querySelector('meta[name="arbor-lambda-commit"]');
  const lambda_commit = lambda_commit_element ? lambda_commit_element.getAttribute('content') : '';
  const lambda_branch_element = document.querySelector('meta[name="arbor-lambda-branch"]');
  const lambda_branch_value = lambda_branch_element?.getAttribute('content');
  const lambda_branch_link = `<a target="_blank" href="https://github.com/optum-rx-pharm-care-svcs/cps-arbor-services/commits/${lambda_branch_value}?deployed=${lambda_commit.substring(
    0,
    8,
  )}">${lambda_branch_value}</a>`;
  // Socket-io
  const socketio_build_date = build_info_response.socketIOConfig?.build_date;
  const socketio_build_date_formatted = formatBuildDate(socketio_build_date);
  const socketio_elapsed_time_delta =
    new Date().getTime() - new Date(socketio_build_date).getTime();
  const socketio_build_time_elapsed = socketio_build_date
    ? elapsedTime(socketio_elapsed_time_delta)
    : '';
  const socketio_running = build_info_response.socketIOConfig?.running_count;
  const socketio_desired = build_info_response.socketIOConfig?.desired_count;
  const socketio_pending = build_info_response.socketIOConfig?.pending_count;
  const socketio_commit = build_info_response?.socketIOConfig?.commit || '';
  const socketio_branch_value = build_info_response?.socketIOConfig?.branch;
  const socketio_branch_link = `<a target="_blank" href="https://github.com/optum-rx-pharm-care-svcs/cps-arbor-socketio/commits/${socketio_branch_value}?deployed=${socketio_commit}">${socketio_branch_value}</a>`;

  // Task Automation
  const task_automation_commit = build_info_response.taskAutomationConfig?.commit || '';
  const task_automation_build_date_formatted = formatBuildDate(
    build_info_response.taskAutomationConfig?.build_date,
  );
  const task_automation_elapsed_time_delta =
    new Date().getTime() - new Date(build_info_response.taskAutomationConfig?.build_date).getTime();
  const task_automation_build_time_elapsed = build_info_response.taskAutomationConfig?.build_date
    ? elapsedTime(task_automation_elapsed_time_delta)
    : '';
  const task_automation_running = build_info_response.taskAutomationConfig?.running_count;
  const task_automation_desired = build_info_response.taskAutomationConfig?.desired_count;
  const task_automation_pending = build_info_response.taskAutomationConfig?.pending_count;
  const task_automation_branch_value = build_info_response.taskAutomationConfig?.branch;
  const task_automation_branch_link = task_automation_branch_value
    ? `<a target="_blank" href="https://github.com/optum-rx-pharm-care-svcs/cps-arbor-task-automation/commits/${task_automation_branch_value}?deployed=${task_automation_commit.substring(
        0,
        8,
      )}">${task_automation_branch_value}</a>`
    : '';
  // Data Migration
  const data_migration_commit = build_info_response.dataMigrationConfig?.commit || '';
  const data_migration_build_date_formatted = formatBuildDate(
    build_info_response.dataMigrationConfig?.build_date,
  );
  const data_migration_build_time_elapsed = build_info_response.dataMigrationConfig?.build_date
    ? elapsedTime(
        new Date().getTime() -
          new Date(build_info_response.dataMigrationConfig?.build_date).getTime(),
      )
    : '';
  const data_migration_running = build_info_response.dataMigrationConfig?.running_count;
  const data_migration_desired = build_info_response.dataMigrationConfig?.desired_count;
  const data_migration_pending = build_info_response.dataMigrationConfig?.pending_count;
  const data_migration_branch_value = build_info_response.dataMigrationConfig?.branch;
  const data_migration_branch_link = data_migration_branch_value
    ? `<a target="_blank" href="https://github.com/optum-rx-pharm-care-svcs/cps-arbor-data-migration/commits/${data_migration_branch_value}?deployed=${data_migration_commit.substring(
        0,
        8,
      )}">${data_migration_branch_value}</a>`
    : '';

  let container = document.getElementById('trellis_build_data_container');
  if (!container) {
    root.insertAdjacentHTML(
      'afterend',
      '<div id="trellis_build_data_container"><div id="trellis_build_data" style="overflow:hidden;position:fixed;top:0;left:0;opacity:0.75;z-index:99999;height:100%;width:100%;background:#999"></div></div>',
    );
  }
  container = document.getElementById('trellis_build_data_container');
  container.insertAdjacentHTML(
    'afterbegin',
    '<div style="z-index:100000;color:black;padding:10px;background:#eef4f9;opacity:1;white-space:nowrap;position:absolute;top:20%;left:50%;width:auto;transform:translateX(-50%);height:auto;border:2px black solid;border-radius: 6px; font-size:16px;line-height:22px"><table id="arbor_build_info_table"><tr><th>Repo</th><th>Branch</th><th>Commit</th><th>Date</th><th>Elapsed Time</th><th style="min-width:90px">Running</th><th style="min-width:90px">Pending</th></table><button style="display:block;margin-top:10px;margin-bottom:10px" id="trellis_build_info_close">Close</button></div>',
  );
  const table_container = document.getElementById('arbor_build_info_table');
  table_container.insertAdjacentHTML(
    'beforeend',
    `<tr><td>UI</td><td>${ui_branch}</td><td>${ui_commit}</td><td>${ui_build_date_formatted}</td><td>${ui_build_time_elapsed}</td><td>n/a</td><td>n/a</td></tr>`,
  );
  table_container.insertAdjacentHTML(
    'beforeend',
    `<tr><td>Services(Docker)</td><td>${services_branch_link}</td><td>${services_commit}</td><td>${services_build_date_formatted}</td><td>${services_build_time_elapsed}</td><td>${services_running}/${services_desired}</td><td>${service_pending}</td></tr>`,
  );
  table_container.insertAdjacentHTML(
    'beforeend',
    `<tr><td>Services(Lambda)</td><td>${lambda_branch_link}</td><td>${lambda_commit}</td><td>${lambda_build_date_formatted}</td><td>${lambda_build_time_elapsed}</td><td>n/a</td><td>n/a</td></tr>`,
  );
  table_container.insertAdjacentHTML(
    'beforeend',
    `<tr><td>SQL</td><td>${sql_branch}</td><td>${sql_commit}</td><td>${sql_build_date_formatted}</td><td>${sql_build_time_elapsed}</td><td>n/a</td><td>n/a</td></tr>`,
  );
  table_container.insertAdjacentHTML(
    'beforeend',
    `<tr><td>Socket-io</td><td>${socketio_branch_link}</td><td>${socketio_commit}</td><td>${socketio_build_date_formatted}</td><td>${socketio_build_time_elapsed}</td><td>${socketio_running}/${socketio_desired}</td><td>${socketio_pending}</td></tr>`,
  );
  table_container.insertAdjacentHTML(
    'beforeend',
    `<tr><td>task-automation</td><td>${task_automation_branch_link}</td><td>${task_automation_commit}</td><td>${task_automation_build_date_formatted}</td><td>${task_automation_build_time_elapsed}</td><td>${task_automation_running}/${task_automation_desired}</td><td>${task_automation_pending}</td></tr>`,
  );
  table_container.insertAdjacentHTML(
    'beforeend',
    `<tr><td>data-migration</td><td>${data_migration_branch_link}</td><td>${data_migration_commit}</td><td>${data_migration_build_date_formatted}</td><td>${data_migration_build_time_elapsed}</td><td>${data_migration_running}/${data_migration_desired}</td><td>${data_migration_pending}</td></tr>`,
  );
  const close_button = document.getElementById('trellis_build_info_close');

  close_button.addEventListener('click', () => close());

  bodyOverflow = document.body.style.overflow;
  document.body.style.overflow = 'hidden';
}

export default displayResults;
